import module from 'usuario/module.js'
import template from './template.html'

const opciones = [
  {id: 1, descripcion: 'Combinar los permisos del usuario seleccionado'},
  {id: 2, descripcion: 'Clonar los permisos del usuario seleccionado'},
  {id: 3, descripcion: 'No realizar acción'},
]

export class UsuarioPermisosClonarComponent {

  usuarios = []
  merge = false
  clonarPermisos = null
  promise = null
  usuarioId = null
  continuar = true
  opciones = opciones
  data = {
    usuario_origen_id: null,
    proyectos: 3,
    modulos: 3,
    empresas: 3,
    clientes: 3,
    cuentas: 3,
    viaticos: 3,
    allClasificaciones: 3,
  }

  constructor (Usuarios, UsuarioPermisosClonar) {
    this.Usuarios = Usuarios
    this.UsuarioPermisosClonar = UsuarioPermisosClonar
  }

  $onInit () {
    this.promise = this.Usuarios.get(0, 0, '', true, this.usuarioId)
      .then((response) => (this.usuarios = response.data))
  }

  all () {
    this.data.proyectos = this.data.allClasificaciones
    this.data.modulos = this.data.allClasificaciones
    this.data.empresas = this.data.allClasificaciones
    this.data.clientes = this.data.allClasificaciones
    this.data.cuentas = this.data.allClasificaciones
    this.data.viaticos = this.data.allClasificaciones
    this.validar()
  }

  clonar () {

    if (this.clonando) return

    this.clonando = true
    this.error = null

    this.UsuarioPermisosClonar.post(this.usuarioId, this.data, this.merge)
      .then(() => (this.clonado = true))
      .catch(({data}) => (this.error = data))
      .finally(() => (this.clonando = false))
  }

  validar () {
    this.continuar = (this.data.proyectos === 3 && this.data.modulos === 3 && this.data.empresas === 3 && this.data.clientes === 3 && this.data.viaticos === 3 && this.data.cuentas === 3)
  }

}

module.component('usuarioPermisosClonar', {
  controller: UsuarioPermisosClonarComponent,
  template,
  bindings: {
    usuarioId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/usuario/components/permisos/clonar/component.js